import React, {Component} from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { LinkContainer } from "react-router-bootstrap";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import GraficResultatsCandidatura from '../elementsResultats/GraficResultatsCandidatura';
import GraficParticipacio from '../elementsResultats/GraficParticipacio';
import BarraEscrutat from '../elementsResultats/BarraEscrutat';
import ReactGA from 'react-ga'
import TaulaGeneral from '../elementsResultats/TaulaGeneral';
import TaulaCandidatures from '../elementsResultats/TaulaCandidatures';
import Alert from 'react-bootstrap/Alert'
import Batalla from '../elementsResultats/Batalla';
import MetaTags from 'react-meta-tags';
import Publicitat from '../estructura/Publicitat'
import Compartir from '../estructura/Compartir';


class DetallMunicipi extends Component {
 
    state = {
        municipiEscollit: null,
        resultats:null,
        textCompartir:null,
        pantalla: 1
    }
 
     trobaNomMunicipi() {
         var codi_generalitat; //Fem una variable que necessitarem més tard
         this.props.municipis.forEach(element => {
             if (element.slug === this.props.match.params.municipiSlug) {
                this.setState({municipiEscollit:element});
                codi_generalitat = element.codi_generalitat;
             } 
         });
         this.props.resultats.forEach(element => {
            if (element.dadesMunicipi.codi == codi_generalitat) this.setState({resultats:element})
        });
     }

     trobaResultats() {
        this.props.resultats.forEach(element => {
            if (element.dadesMunicipi.codi == this.state.municipiEscollit.codi_generalitat) this.setState({resultats:element})
        });
    }
   

    
     componentDidUpdate(prevProps) { //Si es canvia la url que rebem a traves de match, es torna a cridar al backend.
        if (this.props.municipis!==prevProps.municipis||this.props.resultats!==prevProps.resultats) {
            this.trobaNomMunicipi();
            // this.trobaResultats();
        }
      }

      componentDidMount(){ //Si es canvia la url que rebem a traves de match, es torna a cridar al backend.
            this.trobaNomMunicipi();
            ReactGA.pageview(window.location.pathname) //Afegir a cada pàgina que cal comptar
            // this.trobaResultats();

      }
   

    render() {   
        
        if (this.state.municipiEscollit&&this.state.resultats&&this.state.pantalla!==2) {
            this.setState({pantalla:2})


            var textCompartir;

            if (this.state.resultats.dadesElectorals.censEscrutat_per>0) {
                textCompartir = this.state.municipiEscollit.nom + " (" + this.state.resultats.dadesElectorals.censEscrutat_per.toString().replace(/\./g, ',') + "% escrutat): ";

                this.state.resultats.resultatsCandidatures.map((resultat, index) => {
                    if (index<5&&resultat) textCompartir += resultat.sigles.replace(/\s/g, "") + " " + resultat.vots.toLocaleString('en').replace(/\,/g, '.') + " (" + resultat.vots_per.toString().replace(/\./g, ',') + "%) - "
                })

                textCompartir += "Eleccions al Parlament 2021"

                this.setState({textCompartir})
            }

            

            console.log(textCompartir)
        }
        
        return (
            this.state.pantalla===2 && //Només render quan s'han assignat les dades

            <div className="detall_municipi">

                <MetaTags>
                        <title>{this.state.municipiEscollit.nom} - Resultats eleccions al parlament de Catalunya 2021 a {this.state.municipiEscollit.nom}  - Aquí Berguedà</title>
                        <meta name="description" content={"Consulta tots els resultats a " + this.state.municipiEscollit.nom + "de les eleccions al Parlament de Catalunya 2021"} />
                        <meta property="og:title" content={this.state.municipiEscollit.nom + " - Resultats eleccions al Parlament de Catalunya 2021 a " + this.state.municipiEscollit.nom} />
                </MetaTags>

                <Breadcrumb>
                    <LinkContainer to="/resultats/"><Breadcrumb.Item>Municipis</Breadcrumb.Item></LinkContainer>
                    <Breadcrumb.Item active>{this.state.municipiEscollit.nom}</Breadcrumb.Item>
                </Breadcrumb>

                <h5>Resultats provisionals</h5>
                <h2>{this.state.municipiEscollit.nom}</h2>

                {this.state.resultats &&
                <div>
                    {this.state.resultats.dadesElectorals.censEscrutat_per>0 &&
                        <div>
                        
                            <Row className="dadesGenerals">
                                <Col sm={8}>
                                    <p className="escrutat"><BarraEscrutat escrutat={this.state.resultats.dadesElectorals.censEscrutat_per}/></p>
                                    {/* Taula Dades generals */}
                                    <TaulaGeneral dades={this.state.resultats.dadesElectorals}/>
                                </Col>
                                <Col sm={4}><GraficParticipacio participacio={this.state.resultats.dadesElectorals.totalVotants_per} abstencio={this.state.resultats.dadesElectorals.abstencio_per}/></Col>
                            </Row>

                            <Row><Col><Publicitat/></Col></Row>
                        
                            <Row className="dadesCandidatures">
                                {/* Taula Candidatures */}
                                <Col sm={8}>
                                    <TaulaCandidatures partits={this.props.partits} resultats={this.state.resultats.resultatsCandidatures}/>
                                </Col>
                                <Col sm={4}>
                                    <GraficResultatsCandidatura resultats={this.state.resultats.resultatsCandidatures} partits={this.props.partits}/>
                                </Col>
                            </Row>
                            <Compartir url={this.props.match.url} text={this.state.textCompartir}/>
                            {this.props.match.params.opcions&&this.props.match.params.opcions==="batalla" && <Batalla resultatsCandidatures={this.state.resultats.resultatsCandidatures}/>}
                            {/* <Row><Col><Mapa/></Col></Row> */}
                        </div>}

                        {this.state.resultats.dadesElectorals.censEscrutat_per===0 &&
                        <div>
                            <Alert variant='danger'>
                                Encara no hi ha dades per mostrar.
                            </Alert>
                            
                        </div>}

                </div>}

            </div>
        );
    }
}

export default DetallMunicipi; 